export default {
  bindings: {
    model: '=',
    propertyName: '<',
    existingDetails: '<'
  },
  controller: 'customerDetailsController',
  template: require('../views/customer.details.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/components/customer.details.component.js